import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchTenantInvoiceDetails } from "../app/actions";

const TenantPaymentMethod = ({tenant}) => {
    const tenantInvoiceDetails = useSelector(store => store.app.tenantInvoiceDetails);
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(fetchTenantInvoiceDetails(tenant))
    }, [])

    return <div>
        <p style={{opacity: 0.6, padding: "1em", background: "lightgrey"}}><i>No payment method added</i></p>
        <br/>
        <h5>Invoice details</h5>
        <br/>
        {tenantInvoiceDetails && <div>
            <p>Number of users: {tenantInvoiceDetails.number_of_users}</p>  
            <p>Number of languages: {tenantInvoiceDetails.number_of_languages}</p>
            <p>Number of feature flags: {tenantInvoiceDetails.number_of_feature_flags}</p>
            <p>Total feature flags price per month: {tenantInvoiceDetails.total_feature_flags_price_per_month}</p>
        </div>}
    </div>
}

export default TenantPaymentMethod